import { BlocksIconFilterLines } from 'blocks-nextjs/blocks-web-components/components/icon/icons/filter-lines';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconFilterLines = createComponent({ react: React, tagName: 'cat-icon-filter-lines', elementClass: BlocksIconFilterLines });
